const formatNumber = (n) => {
  const l = n.toString();
  return l[1] ? l : `0${l}`;
};
const formateTime = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute, second].map(formatNumber).join(':')}`;
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return [year, month, day].map(formatNumber).join('-');
};

const fomateProductLevel = (riskLevel) => {
  const level = {
    风险承受最低类别: 'R1',
    C1: 'R1及以下',
    C2: 'R2及以下',
    C3: 'R3及以下',
    C4: 'R4及以下',
    C5: 'R5及以下',
  };
  return level[riskLevel];
};
export default {
  formateTime,
  fomateProductLevel,
  formatDate,
};
